export default "__VITE_ASSET__DwHg_h1x__"